module.exports = __webpack_public_path__ + "static/media/search.4955a4d0.svg";